import { Inject, Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromPtCore from '../store/reducers/pt-core.reducer';
import * as PtCoreSelectors from '../store/selectors/pt-core.selectors';
import { map } from 'rxjs/operators';
import * as PtCoreActions from '../store/actions/pt-core.actions';
import { LoggedUser, PtUiAppRoutes } from '@pt/pt-models';
import { UrlUtils } from '../utils';
import { ApiClientConfig } from '@pt/api-client';

@Injectable({
  providedIn: 'root',
})
export class DebugGuardService {
  public loginResponse$ = this.store.select(PtCoreSelectors.loginResponse);

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    private store: Store<fromPtCore.CoreState>
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.loginResponse$.pipe(
      map((loggedUser: LoggedUser) => {
        if (loggedUser.system) {
          return true;
        } else {
          this.store.dispatch(
            PtCoreActions.logoutAndClearData({
              route: [PtUiAppRoutes.LOGIN],
              domain: UrlUtils.getDomainIfExists(),
            })
          );
          return false;
        }
      })
    );
  }
}
